import {
  COMBAT_GOLD_REWARD_SCALE,
  WILD_GOLD_BASE_GEN1,
  WILD_GOLD_BASE_GEN2,
  WILD_GOLD_GEN_EXPONENT,
  WILD_SHINY_GOLD_MULT,
} from "./combat_balance.js";
import { scaleReward, wildGoldFactor } from "./economy_modifiers.mjs";

/** Base or sauvage avant diffScale / shiny / scale global. */
export function getWildGoldBase(gen: number): number {
  const g = Math.max(1, Math.floor(Number(gen) || 1));
  if (g === 1) return WILD_GOLD_BASE_GEN1;
  return Math.round(
    WILD_GOLD_BASE_GEN2 * Math.pow(WILD_GOLD_GEN_EXPONENT, g - 2),
  );
}

/**
 * Or par combat sauvage — aligné client `wildGoldReward.ts` et serveur `wild_gold_per_kill.ts`.
 * `wildGoldFactor()` = modificateur admin live (neutre par défaut).
 */
export function getWildGoldReward(
  gen: number,
  zone: number,
  stage: number,
  shiny: boolean,
): number {
  const localDiff = (zone - 1) * 10 + stage;
  const diffScale = 1 + localDiff * 0.01;
  const goldBase = getWildGoldBase(gen);
  return Math.max(
    1,
    scaleReward(
      goldBase *
        diffScale *
        (shiny ? WILD_SHINY_GOLD_MULT : 1) *
        COMBAT_GOLD_REWARD_SCALE,
      wildGoldFactor(),
    ),
  );
}

export function getWildGoldPerKill(
  gen: number,
  zone: number,
  stage: number,
): number {
  return getWildGoldReward(gen, zone, stage, false);
}
